// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__9sVpi","tab":"Tabs_tab__1nLkA","tabActive":"Tabs_tabActive__2wXTV"};